import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import BackToConversation from '../backToConversation.jsx';

const LargeError = ({ children, heading, imageSrc }) => (
    <div>
        <BackToConversation />
        <div className="centerify">
            <h1 className="t2">{heading}</h1>

            <div className="phl">
                <div className="r-mal">{children}</div>
                <Link className="button r-size1of3 r-mvl" to="/samtale">
                    OK
                </Link>
            </div>

            <img className="mtl ptl" src={imageSrc} />
        </div>
    </div>
);

LargeError.propTypes = {
    children: PropTypes.node.isRequired,
    heading: PropTypes.node.isRequired,
    imageSrc: PropTypes.string.isRequired,
};

export default LargeError;



// WEBPACK FOOTER //
// ./safeTrade/errors/largeError.jsx